import React from 'react';

import KPTable from '../../../../components/KPTComponents/KPTable';

import { ActionColumn } from '../../../../containers/DangKyHoSo/utils';
import { CRUD_MODELS, REWARD_MODEL } from '../../../../constants';

function KhenThuongTable({ rows, setDialog, ...props }) {
  const columns = [
    { ...REWARD_MODEL.title, width: '80%' },
    // { ...REWARD_MODEL.level },
    // { ...REWARD_MODEL.year },
    {
      key: 'link',
      label: 'Tác vụ',
      width: '20%',
      render: (_, row) => (
        <ActionColumn
          row={row}
          type={CRUD_MODELS.REWARD}
          setDialog={setDialog}
          setPreview={props.setPreview}
          setDeleteCrud={props.setDeleteCrud}
        />
      )
    }
  ];

  return (
    <KPTable
      columns={columns}
      nonBorder={!!props.nonBorder}
      rows={rows}
      // loading={loading}
    />
  );
}

export default KhenThuongTable;
